"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "71.44",
    height: "23.99",
    viewBox: "0 0 71.44 23.99"
  }, props), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "60.63",
    y: "5.59",
    width: "3.29",
    height: "1.64",
    fill: "none"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M67.22,5.79A4.12,4.12,0,0,0,63.1,1.68H60.63V3.94h4.12a.82.82,0,0,1,.82.83V8.05a.82.82,0,0,1-.82.83H60.63v3.29h6.59Z",
    fill: "none"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "50.95",
    y: "10.53",
    width: "4.94",
    height: "1.64",
    fill: "none"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "11.44",
    y: "10.53",
    width: "4.93",
    height: "1.64",
    fill: "none"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "44.36",
    y: "10.53",
    width: "4.93",
    height: "1.64",
    fill: "none"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "18.02",
    y: "10.53",
    width: "4.94",
    height: "1.64",
    fill: "none"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "4.85",
    y: "10.53",
    width: "4.93",
    height: "1.64",
    fill: "none"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2.71,19.59a.82.82,0,0,0,.67-1.3,8.93,8.93,0,0,1-1.67-4.47H28.34V12.17H24.6V10.53h3.74V8.88H4a.83.83,0,0,0-.82.83v2.46H.85A.82.82,0,0,0,0,13a10.62,10.62,0,0,0,2,6.26A.82.82,0,0,0,2.71,19.59ZM18,10.53H23v1.64H18Zm-6.58,0h4.92v1.64H11.44Zm-6.59,0H9.78v1.64H4.85Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M42.7,10.53v1.64H41.24v1.65H69.76a8.94,8.94,0,0,1-1.66,4.46.82.82,0,0,0,.19,1.15.83.83,0,0,0,1.15-.19,10.63,10.63,0,0,0,2-6.25.83.83,0,0,0-.83-.82H68.87V5.79A5.78,5.78,0,0,0,63.1,0H59.81A.83.83,0,0,0,59,.85V12.17H57.54V9.71a.83.83,0,0,0-.82-.83H41.24v1.65ZM60.63,5.59h3.3V7.23h-3.3Zm0,3.29h4.12a.82.82,0,0,0,.82-.83V4.77a.82.82,0,0,0-.82-.83H60.63V1.68H63.1a4.12,4.12,0,0,1,4.12,4.11v6.38H60.63ZM51,10.53h4.94v1.64H51Zm-6.59,0h4.93v1.64H44.36Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M70.59,22.27a3.69,3.69,0,0,1-3.16-1.76s0,0,0,0,0,0,0,0a.8.8,0,0,0-.21-.2h0a.91.91,0,0,0-.31-.12h0a1,1,0,0,0-.3,0l0,0a1.27,1.27,0,0,0-.23.08l0,0,0,0a.9.9,0,0,0-.19.2h0a3.7,3.7,0,0,1-6.15.22.94.94,0,0,0-1.35-.5.85.85,0,0,0-.38.53,3.69,3.69,0,0,1-6.1-.21.83.83,0,0,0-.28-.31l-.15-.06-.16-.06h0a.86.86,0,0,0-.58.11.91.91,0,0,0-.3.35,3.7,3.7,0,0,1-6.24,0,.68.68,0,0,0-.23-.25s0,0,0,0,0,0,0,0a.5.5,0,0,0-.13,0l-.18-.07h0a.83.83,0,0,0-.57.11.82.82,0,0,0-.3.34,3.69,3.69,0,0,1-6.15.09.86.86,0,0,0-.34-.42.81.81,0,0,0-.37-.12.83.83,0,0,0-.95.58,3.69,3.69,0,0,1-6.17-.19h0a.63.63,0,0,0-.11-.12.83.83,0,0,0-.14-.13h0l-.05,0a.79.79,0,0,0-.27-.1h0a.83.83,0,0,0-.57.11.75.75,0,0,0-.27.29,3.7,3.7,0,0,1-6.3,0,.77.77,0,0,0-.18-.18.27.27,0,0,0-.07-.08h0a.32.32,0,0,0-.09,0,.85.85,0,0,0-.22-.09h0a.83.83,0,0,0-.57.11.81.81,0,0,0-.29.32,3.7,3.7,0,0,1-6.28,0h0a.63.63,0,0,0-.11-.12.83.83,0,0,0-.14-.13h0l-.05,0a.88.88,0,0,0-.27-.1h0a.83.83,0,0,0-.57.11.75.75,0,0,0-.27.29,3.7,3.7,0,0,1-6.3,0,1.07,1.07,0,0,0-.18-.19.46.46,0,0,1-.07-.07h0l-.09,0-.22-.08h0a.83.83,0,0,0-.57.11.81.81,0,0,0-.29.32A3.71,3.71,0,0,1,.86,22.27.86.86,0,1,0,.86,24a5.38,5.38,0,0,0,3.88-1.64,5.41,5.41,0,0,0,7.76,0,5.41,5.41,0,0,0,7.76,0,5.41,5.41,0,0,0,7.76,0,5.41,5.41,0,0,0,7.74,0A5.37,5.37,0,0,0,39.62,24a5.43,5.43,0,0,0,3.88-1.63,5.41,5.41,0,0,0,7.74,0,5.42,5.42,0,0,0,7.73,0,5.4,5.4,0,0,0,7.73,0A5.36,5.36,0,0,0,70.59,24a.86.86,0,0,0,0-1.72Z"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "29.34",
    y: "4.98",
    width: "10.88",
    height: "10.88",
    fill: "#1d1d1b"
  }));
};

exports["default"] = _default;